<template>
    <svg
        width="128"
        height="128"
        viewBox="0 0 128 128"
        fill="none"
        xmlns="http://www.w3.org/2000/svg">
        <path
            d="M84.5866 33.3812L85.6761 34.2802L86.8132 35.2208C87.3252 35.6435 88.0753 35.5959 88.5278 35.1077L88.5695 35.0601C89.0576 34.5362 89.0041 33.7087 88.4563 33.2502L65.5533 14.08C65.0949 13.693 64.4221 13.693 63.9577 14.0681L39.8699 33.7384C39.2865 34.2147 39.2508 35.0899 39.7925 35.6078C40.245 36.0484 40.9594 36.0781 41.4476 35.6793L63.8922 17.5449C64.3566 17.1699 65.0175 17.1758 65.4759 17.5568L79.9369 29.5293"
            class="primary-fill" />
        <path
            d="M84.5866 33.3812L85.6761 34.2802L86.8132 35.2208C87.3252 35.6435 88.0753 35.5959 88.5278 35.1077L88.5695 35.0601C89.0576 34.5362 89.0041 33.7087 88.4563 33.2502L65.5533 14.08C65.0949 13.693 64.4221 13.693 63.9577 14.0681L39.8699 33.7384C39.2865 34.2147 39.2508 35.0899 39.7925 35.6078C40.245 36.0484 40.9594 36.0781 41.4476 35.6793L63.8922 17.5449C64.3566 17.1699 65.0175 17.1758 65.4759 17.5568L79.9369 29.5293"
            class="primary-stroke"
            stroke-width="2.08372"
            stroke-linecap="round"
            stroke-linejoin="round" />
        <path
            d="M41.5312 35.9769V102.394H88.5936V40.5432"
            class="primary-stroke"
            stroke-width="2.08372"
            stroke-linecap="round"
            stroke-linejoin="round" />
        <path
            d="M41.0957 35.9114H79.3231"
            class="primary-stroke"
            stroke-width="2.08372"
            stroke-linecap="round"
            stroke-linejoin="round" />
        <path
            d="M53.9854 43.014C55.5869 43.014 56.8907 44.3178 56.8907 45.9193V51.4322H51.0801V45.9193C51.0801 44.3178 52.3839 43.014 53.9854 43.014Z"
            class="primary-stroke"
            stroke-width="2.08372"
            stroke-linecap="round"
            stroke-linejoin="round" />
        <path
            d="M65.3272 56.4569C66.9287 56.4569 68.2325 57.7608 68.2325 59.3622V64.8752H62.4219V59.3622C62.4219 57.7608 63.7257 56.4569 65.3272 56.4569Z"
            class="primary-stroke"
            stroke-width="2.08372"
            stroke-linecap="round"
            stroke-linejoin="round" />
        <path
            d="M76.4483 69.7273C78.0498 69.7273 79.3536 71.0311 79.3536 72.6326V78.1455H73.543V72.6326C73.543 71.0311 74.8468 69.7273 76.4483 69.7273Z"
            class="primary-stroke"
            stroke-width="2.08372"
            stroke-linecap="round"
            stroke-linejoin="round" />
        <path
            d="M73.625 47.1874V45.9193C73.625 44.3178 74.9229 43.014 76.5303 43.014C78.1318 43.014 79.4356 44.3119 79.4356 45.9193V51.4322H73.625V50.182"
            class="primary-stroke"
            stroke-width="2.08372"
            stroke-linecap="round"
            stroke-linejoin="round" />
        <path
            d="M62.3027 73.5018V72.2337C62.3027 70.6322 63.6006 69.3284 65.208 69.3284C66.8095 69.3284 68.1133 70.6262 68.1133 72.2337V77.7466H62.3027V76.4964"
            class="primary-stroke"
            stroke-width="2.08372"
            stroke-linecap="round"
            stroke-linejoin="round" />
        <path
            d="M51.2891 60.7673V59.4992C51.2891 57.8977 52.5869 56.5939 54.1944 56.5939C55.7959 56.5939 57.0997 57.8917 57.0997 59.4992V65.0121H51.2891V63.7619"
            class="primary-stroke"
            stroke-width="2.08372"
            stroke-linecap="round"
            stroke-linejoin="round" />
        <path
            d="M62.3926 51.4322V45.9193C62.3926 44.3178 63.6904 43.014 65.2979 43.014C66.8994 43.014 68.2032 44.3119 68.2032 45.9193V51.4322H65.3872"
            class="primary-stroke"
            stroke-width="2.08372"
            stroke-linecap="round"
            stroke-linejoin="round" />
        <path
            d="M51.2227 78.1098V72.5968C51.2227 70.9954 52.5205 69.6915 54.128 69.6915C55.7294 69.6915 57.0333 70.9894 57.0333 72.5968V78.1098H54.2173"
            class="primary-stroke"
            stroke-width="2.08372"
            stroke-linecap="round"
            stroke-linejoin="round" />
        <path
            d="M73.5605 64.8573V59.3444C73.5605 57.7429 74.8584 56.4391 76.4659 56.4391C78.0673 56.4391 79.3712 57.7369 79.3712 59.3444V64.8573H76.5552"
            class="primary-stroke"
            stroke-width="2.08372"
            stroke-linecap="round"
            stroke-linejoin="round" />
        <path
            d="M65.4812 84.5336C69.1188 84.5336 72.0777 87.4865 72.0777 91.13V102.394H58.8848V91.13C58.8848 87.4925 61.8377 84.5336 65.4812 84.5336Z"
            class="primary-stroke"
            stroke-width="2.08372"
            stroke-linecap="round"
            stroke-linejoin="round" />
        <path
            d="M65.4941 102.126V93.9401"
            class="primary-stroke"
            stroke-width="2.08372"
            stroke-linecap="round"
            stroke-linejoin="round" />
        <path
            d="M57.8027 20.6586L63.4824 16.1161C64.3635 15.4136 65.6197 15.4374 66.471 16.1756L84.9209 32.1845C87.1832 34.0837 88.4989 36.8878 88.5108 39.8407L88.8026 90.1298C88.8145 92.035 89.2729 93.9282 90.2195 95.5832C91.5292 97.8694 94.0059 100.281 98.6377 100.281C106.086 100.281 105.258 90.1656 98.4532 90.1656C91.6483 90.1656 85.8556 101.751 90.2671 109.663"
            class="accent-stroke"
            stroke-width="7.73953"
            stroke-miterlimit="10" />
    </svg>
</template>
